import { ProgramNames, PROVIDER_TYPES } from '../../../models'
import { PROGRAM_TAXONOMY, ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

export const DIRECT_ACCESS_MEDS_PROGRAM = {
  programName: ProgramNames.DIRECT_ACCESS_MEDS,
  blendedCareProgramId: null,
  customerPropertyId: ProgramCustomerPropertyId.considerMeds,

  displayLabels: {
    default: ProgramDisplayLabels.lyraCommunityMedications,
    clientProfile: 'Lyra community meds',
    sessionSummary: 'Lyra community medications',
  },

  associatedProviderTypes: [
    PROVIDER_TYPES.PSYCHIATRIST.lyraType,
    PROVIDER_TYPES['PSYCHIATRIC NURSE PRACTITIONER'].lyraType,
    PROVIDER_TYPES['PHYSICIAN ASSISTANT'].lyraType,
  ],
  associatedProviderModalities: ['medication management'],

  canRescheduleAppointment: true,
  selfPayEligible: false,

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [
      TREATMENT_OPTIONS.DIRECT_ACCESS_MEDS,
      TREATMENT_OPTIONS.DIRECT_ACCESS_MEDS_CHILD,
    ],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.individual,
        treatment: PROGRAM_TAXONOMY.treatment.medicationManagement,
        partner: PROGRAM_TAXONOMY.partner.directAccess,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
    ],
    isFullTreatmentOption: true,
  },

  consents: [],

  questionIdentifiers: {
    SI_QUESTION: 'phq9_9',
    SI_PLAN_QUESTION: 'phq9_9_1',
    SI_INTENT_QUESTION: 'phq9_9_2',
  },
} satisfies ProgramConfig

export const DIRECT_ACCESS_THERAPY_PROGRAM = {
  programName: ProgramNames.DIRECT_ACCESS_THERAPY,
  blendedCareProgramId: null,
  customerPropertyId: ProgramCustomerPropertyId.directAccessTherapy,

  displayLabels: {
    default: ProgramDisplayLabels.lyraCommunityTherapy,
    clientProfile: 'Lyra community therapy',
    sessionSummary: 'Lyra community therapy',
  },

  associatedProviderTypes: [PROVIDER_TYPES.THERAPIST.lyraType],
  associatedProviderModalities: ['individual', 'couples', 'family'],

  canRescheduleAppointment: true,
  selfPayEligible: false,

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [
      TREATMENT_OPTIONS.COUPLES_THERAPY,
      TREATMENT_OPTIONS.FAMILY_THERAPY,
      TREATMENT_OPTIONS.INDIVIDUAL_THERAPY,
      TREATMENT_OPTIONS.FAMILY_THERAPY_CHILD,
      TREATMENT_OPTIONS.INDIVIDUAL_THERAPY_CHILD,
    ],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.couples,
        treatment: PROGRAM_TAXONOMY.treatment.therapy,
        partner: PROGRAM_TAXONOMY.partner.directAccess,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
      {
        clientele: PROGRAM_TAXONOMY.clientele.family,
        treatment: PROGRAM_TAXONOMY.treatment.therapy,
        partner: PROGRAM_TAXONOMY.partner.directAccess,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
      {
        clientele: PROGRAM_TAXONOMY.clientele.individual,
        treatment: PROGRAM_TAXONOMY.treatment.therapy,
        partner: PROGRAM_TAXONOMY.partner.directAccess,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
    ],
    isFullTreatmentOption: true,
  },

  consents: [],

  questionIdentifiers: {
    SI_QUESTION: 'phq9_9',
    SI_PLAN_QUESTION: 'phq9_9_1',
    SI_INTENT_QUESTION: 'phq9_9_2',
  },
} satisfies ProgramConfig
